module.exports = __webpack_public_path__ + "static/media/file-full-view.be9801f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/file-full-view.svg
// module id = 441
// module chunks = 0 1